//messages.js
export default {
  general: 'Allgemeines',
  overview: 'Überblick',
  customizer: 'Anpassung',
  applications: 'Anwendungen',
  features: 'Eigenschaften',
  components: 'Komponenten',
  salesAndVisitStats: 'Verkaufs- und Besuchsstatistiken',
  orderAndProjectStats: 'Bestell- und Projektstatistiken',
  fitnessStats: 'Fitness-Statistiken',
  supportAndUsefulWidgets: 'Unterstützung und nützliche Widgets',
  dashboard: 'Instrumententafel',
  dashboardOverview: 'Übersicht über das Dashboard',
  dashboardv1: 'Dashboard V1',
  dashboardv2: 'Dashboard V2',
  widgets: 'Widgets',
  horizontalMenu: 'Horizontales Menü',
  pages: 'Seiten',
  gallery: 'Galerie',
  pricing1: 'Preisgestaltung 1',
  pricing2: 'Preise 2',
  blank: 'Leer',
  session: 'Session',
  signUp1: 'Anmelden 1',
  signUp2: 'Anmelden 2',
  login1: 'Einloggen 1',
  login2: 'Anmelden 2',
  lockScreen: 'Bildschirm sperren',
  uiElements: 'UI-Elemente',
  buttons: 'Tasten',
  cards: 'Karten',
  checkbox: 'Kontrollkästchen',
  carousel: 'Karussell',
  chips: 'Chips',
  datepicker: 'Datumsauswahl',
  dialog: 'Dialog',
  grid: 'Gitter',
  input: 'Eingang',
  list: 'Liste',
  menu: 'Speisekarte',
  progress: 'Fortschritt',
  radio: 'Radio',
  select: 'Wählen',
  slider: 'Schieberegler',
  snackbar: 'Imbissbude',
  tabs: 'Registerkarten',
  toolbar: 'Symbolleiste',
  tooltip: 'Kurzinfo',
  timepicker: 'Zeitzähler',
  forms: 'Formen',
  formValidation: 'Formularüberprüfung',
  stepper: 'Stepper',
  charts: 'Diagramme',
  vueChartjs: 'Chartjs Ansicht',
  vueEcharts: 'Vue Echarts',
  icons: 'Symbole',
  themify: 'Themify',
  material: 'Material',
  tables: 'Tabellen',
  standard: 'Standard',
  slots: 'Schlüssel',
  selectable: 'Wählbar',
  searchRow: 'Zeile suchen',
  maps: 'Karten',
  googleMaps: 'Google Maps',
  leafletMaps: 'Prospektkarten',
  jvectorMap: 'Jvector Karte',
  inbox: 'Posteingang',
  users: 'Benutzer',
  userProfile: 'Benutzerprofil',
  usersList: 'Benutzerliste',
  calendar: 'Kalender',
  editor: 'Editor',
  quillEditor: 'Federredakteur',
  wYSIWYG: 'WYSIWYG',
  vue2Dragula: 'Vue2 Dragula',
  dragAndDrop: 'Ziehen und ablegen',
  vueDraggable: 'Vue schleppbar',
  draggableResizeable: 'Draggable Resizeable',
  chat: 'Plaudern',
  todo: 'Alles',
  modules: 'Module',
  user: 'Benutzer',
  miscellaneous: 'Sonstiges',
  promo: 'Promo',
  connections: 'Verbindungen',
  follow: 'Folgen',
  unfollow: 'Nicht folgen',
  basicValidation: 'Grundlegende Validierung',
  validationWithSubmitAndclear: 'Validierung mit submit & clear',
  submit: 'einreichen',
  clear: 'klar',
  step1: 'Schritt 1',
  step2: 'Schritt 2',
  step3: 'Schritt 3',
  continue: 'Fortsetzen',
  cancel: 'Stornieren',
  totalEarnings: 'Gesamteinnahmen',
  onlineRevenue: 'Online-Umsatz',
  offlineRevenue: 'Offline-Umsatz',
  marketingExpenses: 'Marketingaufwendungen',
  newCustomers: 'neue Kunden',
  visitAndSalesStatistics: 'Besuchs- und Verkaufsstatistik',
  collapse: 'Zusammenbruch',
  reload: 'Neu laden',
  close: 'Schließen',
  bandwidthUsage: 'Bandbreitennutzung',
  shoppingCart: 'Einkaufswagen',
  totalDownloads: 'Gesamtzahl der Downloads',
  productSales: 'Produktverkäufe',
  projectStatus: 'Projekt-Status',
  averageSteps: 'Durchschnittliche Schritte',
  todaysDistance: "Heutige Entfernung",
  todaysStep: "Der heutige Schritt",
  todaysGoal: "Das heutige Ziel",
  calories: 'Kalorien',
  weeklySummary: 'Wöchentliche Zusammenfassung',
  supportTickets: 'Support-Tickets',
  todoList: 'Aufgabenliste',
  newsletterCampaign: 'Newsletter-Kampagne',
  currentVisitors: 'Aktuelle Besucher',
  newMembers: 'Neue Mitglieder',
  addNewBlog: 'Neuen Blog hinzufügen',
  add: 'Hinzufügen',
  logOut: 'Ausloggen',
  totalAppMemory: 'Gesamter App-Speicher',
  totalMemoryUsed: 'Gesamtspeicher verwendet',
  unreadMail: '12 ungelesene Post',
  feedback: 'Feedback',
  flatButton: 'Flacher Knopf',
  raisedButton: 'Erhobener Knopf',
  gradientButton: 'Verlaufsschaltfläche',
  buttonDropdownVariants: 'Schaltflächen Dropdown-Varianten',
  buttonToggle: 'Schaltfläche umschalten',
  icon: 'Symbol',
  normal: 'Normal',
  disabled: 'Behindert',
  floating: 'Schwimmend',
  loaders: 'Lader',
  sizing: 'Größenanpassung',
  outline: 'Gliederung',
  round: 'Runden',
  block: 'Block',
  search: 'Suche',
  checkboxesBoolean: 'Kontrollkästchen Boolean',
  checkboxesArray: 'Kontrollkästchen Array',
  checkboxesStates: 'Checkboxen - Staaten',
  checkboxesColors: 'Checkboxen - Farben',
  switches: 'Schalter',
  default: 'Standard',
  customTransition: 'Benutzerdefinierter Übergang',
  customDelimiter: 'Benutzerdefiniertes Trennzeichen',
  hideControls: 'Steuerelemente ausblenden',
  hideDelimiters: 'Trennzeichen ausblenden',
  colored: 'Farbig',
  label: 'Etikette',
  closeable: 'Verschließbar',
  datePickerHorizontal: 'Datumsauswahl horizontal',
  datePickerVertical: 'Datumsauswahl vertikal',
  datePickersInDialogAndMenu: 'Date Pickers - im Dialog und Menü',
  datePickersWithModal: 'Datumsauswahl mit Modal',
  datePickersFormattingDate: 'Datumsauswahl - Formatierungsdatum',
  simpleDialogs: 'Einfache Dialoge',
  withoutActivator: 'Ohne Aktivator',
  scrollable: 'Scrollbar',
  listOfAllMaterialIcons: 'Liste aller Materialikonen',
  arrowsAndDirectionsIcons: 'PFEILE & RICHTUNG IKONEN',
  webAppIcons: 'WEB-APP-SYMBOLE',
  CONTROLICONS: 'Steuersymbole',
  TEXTEDITOR: 'TEXT EDITOR',
  LAYOUTICONS: 'Layout-Symbole',
  BRANDICONS: 'Marken-ICONS',
  newClients: 'Neue Kunden',
  recurringClients: 'Wiederkehrende Kunden',
  bounceRate: 'Absprungrate',
  pageViews: 'Seitenaufrufe',
  usefulWidgets: 'Nützliche Widgets',
  sale: 'Verkauf',
  sales: 'Der Umsatz',
  invoices: 'Rechnungen',
  referrals: 'Empfehlungen',
  serverLoad: 'Server laden',
  recentSale: 'Neuer Verkauf',
  supportRequest: 'Unterstützungsanfrage',
  productSale: 'Produktverkauf',
  viewAll: 'ALLE ANSEHEN',
  barChart: 'Balkendiagramm',
  polarAreaChart: 'Polares Bereich Diagramm',
  lineChart: 'Liniendiagramm',
  radarChart: 'Radar-Diagramm',
  doughnutChart: 'Donut-Diagramm',
  bubbleChart: 'Blasendiagramm',
  gradientLineChart: 'Gradient Liniendiagramm',
  pieChart: 'Kuchendiagramm',
  funnelChart: 'Trichterdiagramm',
  loginNow: 'Jetzt einloggen',
  createAccount: 'Benutzerkonto anlegen',
  termsOfService: 'Nutzungsbedingungen',
  bySigningUpYouAgreeTo: 'Mit der Anmeldung stimmen Sie zu',
  loginToAdmin: 'Login zum Admin ',
  enterUsernameAndPasswordToAccessControlPanelOf: 'Geben Sie den Benutzernamen und das Passwort ein, um auf das Kontrollfeld von zuzugreifen',
  havingAnAccount: 'Ein Konto haben?',
  quickLinks: 'Schnelle Links',
  plans: 'Pläne',
  chooseThePlanThatWorksForYou: 'Wählen Sie den Plan, der für Sie arbeitet.',
  monthly: 'Monatlich',
  yearlyGet2MonthExtra: 'Jährlich (2 Monate extra)',
  basic: 'Basic',
  pro: 'Profi',
  advanced: 'Fortgeschritten',
  basicFree: 'Grundlegend (Kostenlos)',
  startToBasic: 'Start zu Basic',
  upgradeToPro: 'Upgrade auf Pro.',
  upgradeToAdvance: 'Upgrade zum Vorrücken',
  comparePlans: 'Vergleiche Pläne',
  frequentlyAskedQuestions: 'Häufig gestellte Fragen',
  defaultInput: 'Standardeingabe',
  activator: 'Aktivator',
  hover: 'Schweben',
  menus: 'Menüs',
  indeterminate: 'Unbestimmt',
  sizeAndWidth: 'Größe und Breite',
  rotate: 'Drehen',
  determinate: 'Bestimmt',
  buffer: 'Puffer',
  radiosDefault: 'Radios Standard',
  radiosDirectionRow: 'Radios Richtung Reihe',
  radiosDirectionColumn: 'Radios Richtung Spalte',
  radiosColors: 'Radios - Farben',
  switchesColors: 'Schalter - Farben',
  continuous: 'Kontinuierlich',
  discrete: 'Diskret',
  customColors: 'Benutzerdefinierte Farben',
  editableNumericValue: 'Editierbarer numerischer Wert',
  contextualSnackbar: 'Kontextabhängige Snackbar',
  showSnackbar: 'Zeige Snackbar',
  centeredTabs: 'Zentrierte Registerkarten',
  toolbarTabs: 'Symbolleisten-Registerkarten',
  theDefaultColorToolbar: 'Die Standardfarbensymbolleiste',
  appBar: 'App-Leiste',
  appBarWithExtension: 'App-Leiste mit Erweiterung',
  visibility: 'Sichtweite',
  top: 'oben',
  right: 'Recht',
  bottom: 'Unterseite',
  left: 'Links',
  toggle: 'Umschalten',
  timePicker: 'Zeitauswahl',
  timePickerInDialogAndMenu: 'Zeit Picker - Im Dialog und Menü',
  itemsAndHeaders: 'Elemente und Header',
  selectableRows: 'Auswählbare Zeilen',
  headerCell: 'Auswählbare Zeilen',
  expand: 'Erweitern',
  recentChat: 'Kürzlicher Chat',
  previousChats: 'Vorherige Chats',
  addNewItems: 'Neue Artikel hinzufügen',
  addToDo: 'Zu erledigen',
  yes: 'Ja',
  ok: 'Ok',
  activeUsers: 'Aktive Benutzer',
  addNew: 'Neue hinzufügen',
  readMore: 'Weiterlesen',
  assignNow: 'Jetzt zuweisen',
  totalRequest: 'Gesamtanforderung',
  new: 'Neu',
  pending: 'steht aus',
  update: 'Aktualisieren',
  updated10MinAgo: 'Vor 10 Minuten aktualisiert',
  addNewCustomer: 'Neuen Kunden hinzufügen',
  name: 'Name',
  email: 'Email',
  editMember: 'Mitglied bearbeiten',
  scheduleDate: 'Zeitplan Datum',
  title: 'Titel',
  newEmails: 'Neue E-Mails',
  newEmail: 'Neue e-mail',
  employeePayroll: 'Personalabrechnung',
  forMostOfTheUsers: 'Für die meisten Benutzer',
  choosePlan: 'Wählen Sie Pla',
  mega: 'Mega',
  master: 'Meister',
  forDeveloper: 'Für Entwickler',
  forLargeEnterprises: 'Für große Unternehmen',
  composeEmail: 'E-Mail verfassen',
  mailboxes: 'Postfächer',
  folders: 'Ordner',
  inbox5: 'Eingang (5)',
  draft: 'Entwurf',
  starred: 'Markiert',
  sentMessages: 'Gesendeten Nachrichten',
  spam: 'Spam',
  delete: 'Löschen',
  work: 'Arbeit',
  personal: 'persönlich',
  manageFolders: 'Ordner verwalten',
  contacts: 'Kontakte',
  settings: 'die Einstellungen',
  themeOptions: 'Designoptionen',
  darkMode: 'Dunkler Modus',
  collapseSidebar: 'Sidebar ausblenden',
  boxLayout: 'Box-Layout',
  rtlLayout: 'Rtl Layout',
  backgroundImage: 'Hintergrundbild',
  sidebarFilters: 'Sidebar-Filter',
  danger: 'Achtung',
  primary: 'Primär',
  warning: 'Warnung',
  success: 'Erfolg',
  info: 'Info',
  dailySales: 'Tägliche Verkäufe',
  trafficChannel: 'Verkehrskanal',
  campaignPerformance: 'Kampagnenleistung',
  goToCampaign: 'Gehe zur Kampagne',
  fullScreen: 'Vollbild',
  ecommerce: 'E-Commerce',
  shop: 'Geschäft',
  cart: 'Wagen',
  total: 'Gesamt',
  totalPrice: 'Gesamtpreis',
  viewCart: 'Warenkorb ansehen',
  checkout: 'Auschecken',
  apply: 'Sich bewerben',
  noItemsFound: 'Keine Elemente gefunden',
  billingDetails: 'Rechnungsdetails',
  placeOrder: 'Bestellung aufgeben',
  addNewCard: 'Neue Karte hinzufügen',
  devicesShare: 'Geräte teilen',
  customerOverview: 'Kundenübersicht',
  reviews: 'Bewertungen',
  weeklySales: 'Wöchentliche Verkäufe',
  recentOrders: 'letzte Bestellungen',
  categorySales: 'Kategorie Verkauf',
  webAnalytics: 'Netz Analyse',
  topSelling: 'Meistverkauft',
  social: 'Sozial',
  newPost: 'Neue Post',
  publish: 'Veröffentlichen',
  magazine: 'Zeitschrift',
  editUser: 'Benutzer bearbeiten',
  addNewUser: 'Neuen Benutzer hinzufügen',
  dark: 'Dunkel',
  light: 'Licht',
  recentUsers: 'Letzte Benutzer',
  activityAroundWorld: 'Aktivität um die Welt',
  adsIncome: 'Anzeigen Einnahmen',
  recentComments: 'Letzte Kommentare',
  recentNotifications: 'Letzte Benachrichtigungen',
  messages: 'Mitteilungen',
  edit: 'Bearbeiten',
  topAuthors: 'Top Autoren',
  marketingCampaign: 'Vermarktungskampagne',
  articles: 'Artikel',
  websiteTraffic: 'Website-Verkehr',
  agency: 'Agentur',
  recent: 'Kürzlich',
  trending: 'Trend',
  totalPageViews: 'Absolute Seitenaufrufe',
  impressions: 'Eindrücke',
  deviceSeparations: 'Gerätetrennungen',
  browserStatics: 'Browserstatistiken',
  totalDownloading: 'Gesamtdownload',
  notifications: 'Benachrichtigungen',
  totalBookmarked: 'Insgesamt mit einem Lesezeichen versehen',
  itemsDownloads: 'Artikel Downloads',
  itemsUploaded: 'Elemente hochgeladen',
  totalAnalytics: 'Gesamtanalyse',
  hotKeywords: 'Heiße Schlüsselwörter',
  MaleUsers: 'Männliche Benutzer',
  serverStatus: 'Server Status',
  purchaseVuely: 'Kaufen Sie Vuely',
  letsGetInTouch: 'Lass uns in Kontakt kommen',
  maleUsers: 'Männliche Benutzer',
  femaleUsers: 'Weibliche Benutzer',
  androidUsers: 'Android Benutzer',
  iOSUsers: 'iOS-Benutzer',
  advance: 'Vorrücken',
  routerAnimation: 'Router-Animation',
  salesAndEarning: 'Verkauf und verdienen',
  netProfit: 'Reingewinn',
  totalExpences: 'Gesamtausgaben',
  photos: 'Fotos',
  adCampaignPerfomance: 'Leistung der Anzeigenkampagne',
  profitShare: 'Erfolgsbeteiligung',
  topSellingTheme: 'Meistverkauftes Thema',
  newRequest: 'Neue Anfrage',
  followers: 'Anhänger',
  mailbox: 'Briefkasten',
  sent: 'Geschickt',
  birthdays: 'Geburtstage',
  events: 'Veranstaltungen',
  newsletter: 'Newsletter',
  lastMonth: 'Im vergangenen Monat',
  allTime: 'Die ganze Zeit',
  composeNewEmail: 'Verfassen Sie eine neue E-Mail',
  activity: 'Aktivität',
  message: 'Botschaft',
  selectTheme: 'Thema wählen',
  continueShopping: 'Mit dem Einkaufen fortfahren',
  proceedToCheckout: 'Zur Kasse',
  headerFilters: 'Header-Filter',
  blog: "Blog",
  signUp: "Anmelden",
  login: "Anmeldung                                                             ",
  news: "Nachrichten",
  topHeadlines: "Top Schlagzeilen",
  visitors: "Besucher",
  subscribers: "Abonnenten",
  twitterFeeds: "Twitter-Feeds",
  extensions: "Erweiterungen",
  imageCropper: "Bildkrämer",
  videoPlayer: "Videoplayer",
  dropzone: "Abwurfgebiet",
  baseConfig: "Basiskonfiguration",
  audioTrackAndPlaysInline: "Audio Track und spielt Inline",
  hlsLive: "HLS Live",
  forgotPassword: "Passwort vergessen",
  resetPassword: "Passwort zurücksetzen",
  backToSignIn: "Zurück zum Anmelden",
  enterYourEmailToSendYouAResetLink: "Geben Sie Ihre E-Mail-Adresse ein, um Ihnen einen Link zum Zurücksetzen zu senden",
  pleaseEnterYourPasswordToReset: "Bitte geben Sie Ihr Passwort zum Zurücksetzen ein",
  saas: "SAAS",
  overallTrafficStatus: "Gesamtverkehrsstatus",
  projectManagement: "Projektmanagement",
  projectTaskManagement: "Projektaufgabenverwaltung",
  totalSales: "Gesamtumsatz",
  simple: "Einfach",
  transitions: "Übergänge",
  tax: "MwSt",
  expenses: "Kosten",
  images: "Bilder",
  ratings: "Bewertungen",
  containAndCover: 'Enthalten und abdecken',
  height: 'Höhe',
  fixedRatio: 'Konstantes Verhältnis',
  gradients: 'Farbverläufe',
  sizeVariants: 'Größenvarianten',
  newIcons: 'Neue Symbole',
  webApplication: 'Internetanwendung',
  person: 'Person',
  file: 'Datei',
  comment: 'Kommentar',
  form: 'Bilden',
  hardware: 'Hardware',
  directional: 'Richtungsweisend',
  mapAliases: 'Karte (Aliasse)',
  dateAndTime: 'Datum und Uhrzeit'
}
